export default __webpack_public_path__ + "static/media/receipt-dollar.00093a71.svg";